export enum CloseInvertEnum {
  CLOSE = 1,
  INVERT = 2,
}
